module.exports = __webpack_public_path__ + "3f8fb18077910b7f88a0808d9a1db4b9.png";